import { Component, Input, OnInit } from '@angular/core';
import { NamedIdentityDTO } from 'src/app/services/api/api';
import { SbModalState } from '../modal-state.service';
import { SelectOptions, SelectValue } from '../modal.model';
import { UtilService } from '../../../util.service';

@Component({
  selector: 'sb-select-modal',
  templateUrl: './sb-select-modal.component.html',
  styleUrls: ['./sb-select-modal.component.scss'],
  standalone: false,
})
export class SbSelectModalComponent implements OnInit {
  options: SelectOptions<any>;
  @Input()
  templateId: string;
  selectedOption: SelectValue<any>;

  searchStr: string;

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as SelectOptions<any>;
    this.selectedOption = this.options.initialValue;
  }

  constructor(
    private state: SbModalState,
    public util: UtilService
  ) {}

  setSelectedOption<T>(selectedOption: SelectValue<T>) {
    this.selectedOption = selectedOption;
  }

  search($event) {
    this.searchStr = $event;
  }

  getClass<T>(option: SelectValue<T>) {
    if (this.selectedOption && this.normalize(this.selectedOption.value) === this.normalize(option.value)) {
      return 'selected';
    }
    return '';
  }

  normalize(blah) {
    if (blah instanceof NamedIdentityDTO) {
      return blah;
    }

    return blah + '';
  }

  ok() {
    if (this.checkOkEnabled()) {
      this.state.modals.get(this.templateId).close({
        value: this.selectedOption,
        cancel: false,
      });
    }
  }

  checkOkEnabled() {
    return this.selectedOption !== null;
  }

  cancel() {
    this.state.modals.get(this.templateId).close({
      value: null,
      cancel: true,
    });
  }
}
